// Non-UK checkout -> enquiry modal swap (cart page + mini-cart drawer only).
// Only loaded for shoppers whose country isn't blank/"GB" (see layout/theme.liquid).
(function () {
  var scrollPositionKey = 'internationalEnquiryScrollY';
  var submissionPendingKey = 'internationalEnquirySubmissionPending';

  function isNonUkShopper() {
    var country = window.theme && window.theme.country;
    if (!country) return false;
    return country !== 'GB';
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2);
  }

  function renderSummary(modal, cart) {
    var summaryEl = modal.querySelector('[data-international-enquiry-summary]');
    var hiddenField = modal.querySelector('[data-international-enquiry-cart-field]');

    if (!cart || !cart.items || !cart.items.length) {
      if (summaryEl) summaryEl.innerHTML = '';
      if (hiddenField) hiddenField.value = '';
      return;
    }

    var lines = cart.items.map(function (item) {
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? ' - ' + item.variant_title : '';
      return item.quantity + ' x ' + item.product_title + variant;
    });

    if (summaryEl) {
      var listItems = cart.items.map(function (item) {
        var variant = (item.variant_title && item.variant_title !== 'Default Title') ? ' - ' + item.variant_title : '';
        var rest = (item.product_title + variant).replace(/</g, '&lt;');
        return '<li><strong>' + item.quantity + ' x</strong> ' + rest + '</li>';
      }).join('');
      summaryEl.innerHTML = '<ul class="international-enquiry__cart-list">' + listItems + '</ul>';
    }

    if (hiddenField) {
      hiddenField.value = lines.join('\n') + '\nTotal: ' + formatMoney(cart.total_price);
    }
  }

  function renderSummaryError(modal) {
    var summaryEl = modal.querySelector('[data-international-enquiry-summary]');
    var hiddenField = modal.querySelector('[data-international-enquiry-cart-field]');
    if (summaryEl) {
      summaryEl.innerHTML = '<p>We couldn\'t load your cart automatically, that\'s okay, just tell us what you\'re after below.</p>';
    }
    if (hiddenField) hiddenField.value = '';
  }

  function fetchCartWithTimeout(timeoutMs) {
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = setTimeout(function () {
        if (settled) return;
        settled = true;
        reject(new Error('cart fetch timed out'));
      }, timeoutMs);

      fetch('/cart.js')
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          resolve(cart);
        })
        .catch(function (err) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          reject(err);
        });
    });
  }

  function closeMiniCartIfOpen() {
    var miniCart = document.getElementById('mini-cart');
    if (!miniCart || miniCart.getAttribute('aria-hidden') !== 'false') return;

    var toggle = document.querySelector('[data-action="toggle-mini-cart"]');
    if (toggle) toggle.click();
  }

  function openEnquiryModal() {
    var trigger = document.getElementById('international-enquiry-invisible-trigger');
    var modal = document.getElementById('modal-international-enquiry');
    if (!trigger || !modal) return;

    closeMiniCartIfOpen();

    fetchCartWithTimeout(4000)
      .then(function (cart) { renderSummary(modal, cart); })
      .catch(function () { renderSummaryError(modal); })
      .finally(function () {
        trigger.click();
        setUkSwitchVisible(true);
        setBodyScrollLocked(true);
      });
  }

  function handleClick(event) {
    if (event.target.closest('#international-enquiry-uk-switch')) {
      event.stopPropagation();
      return;
    }

    var target = event.target.closest('[data-checkout-button]');
    if (!target) return;
    if (!isNonUkShopper()) return;
    if (!document.getElementById('modal-international-enquiry')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    openEnquiryModal();
  }

  function setUkSwitchVisible(visible) {
    var banner = document.getElementById('international-enquiry-uk-switch');
    if (!banner) return;
    banner.classList.toggle('is-visible', !!visible);
    updateUkSwitchHeightVar(banner, visible);
  }

  // Feeds the banner's real rendered height into a CSS variable so the
  // modal's box can stop exactly above it (see snippets/international-enquiry-modal.liquid).
  function updateUkSwitchHeightVar(banner, visible) {
    var height = visible ? banner.offsetHeight : 0;
    document.documentElement.style.setProperty('--international-enquiry-uk-switch-height', height + 'px');
  }

  window.addEventListener('resize', function () {
    var banner = document.getElementById('international-enquiry-uk-switch');
    if (banner && banner.classList.contains('is-visible')) {
      updateUkSwitchHeightVar(banner, true);
    }
  });

  function setBodyScrollLocked(locked) {
    document.body.style.overflow = locked ? 'hidden' : '';
    document.body.classList.toggle('international-enquiry-modal-open', locked);
  }

  function rememberScrollPosition() {
    try {
      window.sessionStorage.setItem(scrollPositionKey, String(window.scrollY || window.pageYOffset || 0));
      window.sessionStorage.setItem(submissionPendingKey, 'true');
    } catch (err) {
      // Storage can be unavailable in restrictive privacy modes; submission can continue normally.
    }
  }

  function applySubmissionFallback(modal) {
    var submissionPending = false;
    var returnedToForm = window.location.hash === '#contact_form' || window.location.hash === '#international-enquiry-contact-form';

    try {
      submissionPending = window.sessionStorage.getItem(submissionPendingKey) === 'true';
      window.sessionStorage.removeItem(submissionPendingKey);
    } catch (err) {
      submissionPending = false;
    }

    if (!submissionPending || !returnedToForm || modal.getAttribute('data-international-enquiry-status') === 'error') return;

    var successEl = modal.querySelector('[data-international-enquiry-success]');
    var fieldsEl = modal.querySelector('[data-international-enquiry-fields]');
    var formTitleEl = modal.querySelector('[data-international-enquiry-form-title]');
    var dialogEl = modal.querySelector('.modal__dialog');

    if (successEl) successEl.hidden = false;
    if (fieldsEl) fieldsEl.hidden = true;
    if (formTitleEl) formTitleEl.hidden = true;
    if (dialogEl) dialogEl.setAttribute('aria-labelledby', 'international-enquiry-success-title');

    modal.setAttribute('data-international-enquiry-status', 'success');
    modal.setAttribute('aria-hidden', 'false');
  }

  function cleanUpSubmissionRedirect() {
    var savedScrollPosition = null;

    try {
      savedScrollPosition = window.sessionStorage.getItem(scrollPositionKey);
      window.sessionStorage.removeItem(scrollPositionKey);
    } catch (err) {
      savedScrollPosition = null;
    }

    if ((window.location.hash === '#contact_form' || window.location.hash === '#international-enquiry-contact-form') && window.history && window.history.replaceState) {
      window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
    }

    if (savedScrollPosition !== null) {
      var scrollY = parseInt(savedScrollPosition, 10);
      if (!isNaN(scrollY)) {
        window.scrollTo(0, scrollY);
        window.requestAnimationFrame(function () {
          window.scrollTo(0, scrollY);
        });
      }
    }
  }

  document.addEventListener('click', handleClick, true);

  var enquiryFormEl = document.getElementById('international-enquiry-contact-form');
  if (enquiryFormEl) {
    enquiryFormEl.addEventListener('submit', rememberScrollPosition);
  }

  var enquiryModalEl = document.getElementById('modal-international-enquiry');
  if (enquiryModalEl) {
    applySubmissionFallback(enquiryModalEl);
    enquiryModalEl.addEventListener('modal:closed', function () {
      setUkSwitchVisible(false);
      setBodyScrollLocked(false);
    });
    if (enquiryModalEl.getAttribute('aria-hidden') === 'false') {
      var submissionStatus = enquiryModalEl.getAttribute('data-international-enquiry-status');
      cleanUpSubmissionRedirect();
      setUkSwitchVisible(submissionStatus !== 'success');
      setBodyScrollLocked(true);
    }
  }
})();
